// services/tables.js
import { getSubdomain, fetchWithAuth } from "../helpers";
import { API_PASSWORD } from "../config";


export const getMenusPublic = async () => {
    const subdomain = getSubdomain();
    const apiPassword = API_PASSWORD;
    const url = `https://${subdomain}.restocash.app/api/get/menus?api_password=${apiPassword}`;

    try {
        const response = await fetch(url, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error(`Error fetching menus: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Failed to fetch menus:", error);
        throw error;
    }
};


// التحقق من حالة الطاولة عبر QR
export const checkTableByQr = async (qr_code) => {
    const subdomain = getSubdomain();
    const apiPassword = API_PASSWORD;
    const token = localStorage.getItem("token");
    const url = `https://${subdomain}.restocash.app/api/check/table/by/qrcode/${qr_code}?api_password=${apiPassword}`;

    const response = await fetch(url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data?.message || "فشل في التحقق من حالة الطاولة.");
    }

    return data;
};




export const getOffersPublic = async (rootId) => {
  const subdomain = getSubdomain();
  const apiPassword = API_PASSWORD;

  // خلي rootId بدل 1
  const url = `https://${subdomain}.restocash.app/api/get/api/offers/${rootId}?api_password=${apiPassword}`;

  console.log("📡 Requesting offers from:", url);

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Accept": "application/json",
      },
    });

    if (!response.ok) {
      const errText = await response.text();
      console.error("❌ Server response:", errText);
      throw new Error(`Error fetching offers: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("❌ Failed to fetch offers:", error);
    throw error;
  }
};

// NEW: دالة لجلب العروض العامة بدون rootId (مطابقة لنموذج الطلب في الصورة)
export const getOffersPublicAll = async (apiPasswordOverride = null) => {
  const subdomain = getSubdomain();
  const apiPassword = apiPasswordOverride || API_PASSWORD;
  const url = `https://${subdomain}.restocash.app/api/get/api/offers?api_password=${apiPassword}`;

  console.log("📡 Requesting public offers (all) from:", url);

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      const text = await response.text();
      console.error("❌ Server response:", text);
      throw new Error(`Error fetching public offers: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("❌ Failed to fetch public offers:", error);
    throw error;
  }
};

// إنشاء طلب توصيل (Delivery Order)
export const makeDeliveryOrder = async (formData) => {
  const subdomain = getSubdomain();
  const apiPassword = API_PASSWORD;
  const url = `https://${subdomain}.restocash.app/api/make/delivery/order?api_password=${apiPassword}`;

  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData, // يجب أن يكون formData من نوع FormData
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "فشل في إنشاء طلب التوصيل.");
    }

    return data;
  } catch (error) {
    console.error("❌ فشل في إنشاء طلب التوصيل:", error);
    throw error;
  }
};
// جلب البيانات العامة (الهيدر / الفوتر وبيانات الفرع العامة)
export const getPublicData = async () => {
  const subdomain = getSubdomain();
  const apiPassword = API_PASSWORD;
  const url = `https://${subdomain}.restocash.app/api/public/data?api_password=${apiPassword}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || `Error fetching public data: ${response.statusText}`);
      
    }
    

    // في بعض الـ API تكون الهيكلة { data: { data: { ... } } }
    return data?.data?.data ?? data?.data ?? data;
  } catch (error) {
    console.error("Failed to fetch public data:", error);
    throw error;
  }
};

